// Action icon registry for the unified Actions modal.
//
// Icon slugs are chosen by the server in compute_actions.go (CharacterAction.Icon)
// so the frontend never needs to know which kind of action it's drawing. Each
// slug maps to a static, trusted inline SVG template in the generated
// action-icon-svgs.js module (lucide-derived stroke icons and our own
// scripts/icon-sources/ artwork — see that file's header for regeneration).
// Every icon inherits `currentColor` so hover/disabled states tint cleanly,
// and parents control sizing. Adding a new icon = regenerate/add the template
// in action-icon-svgs.js, keyed by the new slug.

import { ACTION_ICONS } from './action-icon-svgs.js';

/**
 * Render an action icon by registry slug.
 * @param {string | undefined} slug
 * @returns {import('lit').TemplateResult}
 */
export function renderActionIcon(slug) {
  return ACTION_ICONS[slug || ''] || ACTION_ICONS.action;
}

// Display order for action-type groups in the modal. Matches the D&D 2024
// player rulebook's reference list (alphabetical by action type) with our
// extra "special" bucket pinned at the end so game-flow actions like
// Initiate Combat don't get lost in the middle.
export const ACTION_TYPE_ORDER = [
  'attack',
  'dash',
  'disengage',
  'dodge',
  'help',
  'hide',
  'influence',
  'magic',
  'ready',
  'search',
  'study',
  'utilize',
  'special',
];

const ACTION_TYPE_LABELS = {
  attack: 'Attack',
  dash: 'Dash',
  disengage: 'Disengage',
  dodge: 'Dodge',
  help: 'Help',
  hide: 'Hide',
  influence: 'Influence',
  magic: 'Magic',
  ready: 'Ready',
  search: 'Search',
  study: 'Study',
  utilize: 'Utilize',
  special: 'Special',
};

/** @param {string | undefined} type */
export function actionTypeLabel(type) {
  return ACTION_TYPE_LABELS[type || ''] || 'Special';
}
